
import state from './tasksState.js'
import * as mutations from './tasksMutations.js'
import * as actions from './tasksActions.js'
import * as getters from './tasksGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}